module.exports = __webpack_public_path__ + "img/meus dados.33c580e4.svg";